import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import { css } from "@mui/material/styles";
import { COLOR_PRIMARY_MAIN, COLOR_WHITE } from "shared/theme/colors";

export const StyledExpandIcon = styled(Box, {
  shouldForwardProp: (propName) => propName !== "open",
})<{ open: boolean }>`
  svg {
    transform: ${(props) => (props.open ? "rotate(180deg)" : "rotate(360deg)")};
  }
`;

export const StyledCollapserButton = styled(ButtonBase, {
  shouldForwardProp: (propName) => !["active", "expanded"].includes(propName),
})<{
  active: boolean;
  expanded?: boolean;
}>`
  width: ${({ expanded }) => (expanded ? "100%" : "max-content")};
  display: flex;
  text-align: left;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  cursor: pointer;
  border-radius: 0.5rem;
  text-decoration: none;
  height: 40px;
  box-sizing: border-box;

  :hover {
    span {
      color: ${COLOR_WHITE};
    }

    svg > path {
      fill: ${COLOR_WHITE};
    }
  }

  ${(props) =>
    props.active &&
    css`
      background-color: ${COLOR_PRIMARY_MAIN};

      . {
        color: ${COLOR_WHITE};
      }

      svg > path {
        fill: ${COLOR_WHITE};
      }
    `}
`;
